// extracted by mini-css-extract-plugin
export default {"main":"Queue_main__9I1cC"};